export default __webpack_public_path__ + "static/media/twitter_icon.a9a505bc.png";